import React from "react";

const Out = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M31.096 2.02C31.063 2.017 31.035 2 31 2H16.666c-2.206 0-4 1.795-4 4v1.333a1.334 1.334 0 002.666 0V6c0-.735.6-1.333 1.334-1.333h6.212l-.407.136a2.68 2.68 0 00-1.805 2.53v20h-4A1.336 1.336 0 0115.332 26v-2.667a1.334 1.334 0 00-2.666 0V26c0 2.205 1.794 4 4 4h4v1.333A2.67 2.67 0 0023.333 34c.285 0 .556-.041.85-.132l8.01-2.67A2.68 2.68 0 0034 28.666v-24c0-1.555-1.34-2.774-2.904-2.647z"
              fill={fill}
        />
        <path className="u_fill"
            d="M16.277 14.39l-5.333-5.334A1.333 1.333 0 008.667 10v4H3.335a1.334 1.334 0 000 2.666h5.334v4a1.333 1.333 0 002.276.943l5.333-5.333a1.332 1.332 0 000-1.886z"
              fill={fill}
        />
    </svg>
);

export default Out;